import { PropertyWizardContext } from 'context/Context';
import PropTypes from 'prop-types';
import { useState } from 'react';

const PropertyWizardProvider = ({
  children,
  className,
  style,
  handleSubmit,
  yupSubmitRef,
  step,
  setStep,
  data,
  setData,
  stepStatus,
  setStepStatus,
  setAction,
  handleNavs,
  status,
  form,
  types
}) => {
  const [scrollToBottom, setScrollToBottom] = useState(true);

  const value = {
    scrollToBottom,
    setScrollToBottom,
    handleSubmit,
    yupSubmitRef,
    step,
    setStep,
    data,
    setData,
    stepStatus,
    setStepStatus,
    setAction,
    handleNavs,
    status,
    form,
    types
  };

  return (
    <div className={className} style={style}>
      <PropertyWizardContext.Provider value={value}>
        {children}
      </PropertyWizardContext.Provider>
    </div>
  );
};

PropertyWizardProvider.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  yupSubmitRef: PropTypes.object.isRequired,
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  data: PropTypes.object,
  setData: PropTypes.func.isRequired,
  stepStatus: PropTypes.object,
  setStepStatus: PropTypes.func.isRequired,
  setAction: PropTypes.func.isRequired,
  handleNavs: PropTypes.func.isRequired,
  status: PropTypes.string,
  form: PropTypes.object,
  types: PropTypes.array
};

export default PropertyWizardProvider;
